import React from 'react';
import { Button, Tooltip } from "antd";
// Componentes por eliminar: TooltipButtonIcon
const TooltipButtonIcon = ({
  tooltipTitle = "",
  btnSize = "small",
  type = "",
  ghost = false,
  onClick = () => { },
  style = {
    borderColor: "transparent",
    display: "flex",
    boxShadow: "none"
  },
  icon = null,
}) => {
  return (
    <Tooltip title={tooltipTitle}>
      <Button
        size={btnSize}
        type={type}
        ghost={ghost}
        onClick={onClick}
        style={style}
      >
        {icon}
      </Button>
    </Tooltip>
  );
};

export default TooltipButtonIcon;